export default "__VITE_ASSET__BteIbyl2__"